import React, { useEffect } from "react";
import { Form, Input, Button, Typography } from "antd";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Contact.css";

const { TextArea } = Input;

const Contact = () => {
   useEffect(() => {
      document.title = "Contact | Amresh Kumar";

      const metaDescription = document.querySelector(
         'meta[name="description"]'
      );

      if (metaDescription) {
         metaDescription.setAttribute(
            "content",
            "Contact Amresh Kumar for React.js, Django, CRM, ERP and full stack web development projects."
         );
      }

      AOS.init({
         duration: 500,
         once: false,
         mirror: true,
         easing: "ease-in-out",
      });
   }, []);

   const handleSubmit = (values) => {
      const { name, email, subject, message } = values;

      const mailSubject = encodeURIComponent(subject);

      const mailBody = encodeURIComponent(
         `Name: ${name}

Email: ${email}

Message:
${message}`
      );

      const mailto = `mailto:amresh1kumar0111@zohomail.in?subject=${mailSubject}&body=${mailBody}`;

      window.location.href = mailto;
   };

   return (
      <div className="contact-dark-bg">
         <div className="contact-dark-container">
            <div className="contact-dark-paper" data-aos="fade-down">

               <Typography.Title
                  level={2}
                  className="contact-dark-title"
               >
                  Get in Touch
               </Typography.Title>

               <Form
                  layout="vertical"
                  onFinish={handleSubmit}
                  className="contact-dark-form"
                  requiredMark={false}
               >

                  <Form.Item
                     label="Name"
                     name="name"
                     rules={[
                        {
                           required: true,
                           message: "Please enter your name",
                        },
                     ]}
                  >
                     <Input
                        size="large"
                        placeholder="Enter your name"
                     />
                  </Form.Item>

                  <Form.Item
                     label="Email"
                     name="email"
                     rules={[
                        {
                           required: true,
                           message: "Please enter your email",
                        },
                        {
                           type: "email",
                           message: "Please enter a valid email",
                        },
                     ]}
                  >
                     <Input
                        type="email"
                        size="large"
                        placeholder="Enter your email"
                     />
                  </Form.Item>

                  <Form.Item
                     label="Subject"
                     name="subject"
                     rules={[
                        {
                           required: true,
                           message: "Please enter a subject",
                        },
                     ]}
                  >
                     <Input
                        size="large"
                        placeholder="Enter subject"
                     />
                  </Form.Item>

                  <Form.Item
                     label="Message"
                     name="message"
                     rules={[
                        {
                           required: true,
                           message: "Please enter your message",
                        },
                     ]}
                  >
                     <TextArea
                        rows={5}
                        placeholder="Enter your message"
                        maxLength={1000}
                        showCount
                     />
                  </Form.Item>

                  <Form.Item>
                     <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        block
                        className="contact-dark-submit"
                     >
                        Submit
                     </Button>
                  </Form.Item>

               </Form>
            </div>
         </div>
      </div>
   );
};

export default Contact;